var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-down"},[_c('v-icon',{staticClass:"work-down-icon animated swing"},[_vm._v("check")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }